<template>
	<div class="page">
		<slot></slot>
	</div>
</template>
<script>
	export default { name: 'page' }
</script>


// WEBPACK FOOTER //
// src/components/page/page.vue